import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Equipments = ({ roles }) => {
    return (
        <M_Table entityName={'EquipmentType'} rolePermissions={roles} filtersOnTable />
    )
}